const de = {
  type: {
    flat: 'Wohnung',
    study: 'Studium',
    belongings: 'Allgemein'
  },
  steps: {
    category: 'Kategorie',
    offer: 'Angebot',
    personalContacts: 'Kontaktdaten',
    review: 'Überprüfung & Publikation'
  },
  create: {
    title: 'Neues Inserat',
    category: {
      selectCategory: 'Kategorie wählen',
      studyDescription:
        'Materialien mit Studienbezug, wie z.B. Bücher, Werkzeuge o.ä. können hier inseriert werden',
      flatDescription: 'Hier können Angebote oder Gesuche für Wohnungen oder WGs inseriert werden',
      belongingsDescription:
        'Hier kann alles inseriert werden, was nicht in die übrigen Kategorien eingeordnet werden kann'
    },
    offer: {
      offerText: 'Angebotsbeschreibung',
      address: 'Abholadresse',
      photos: 'Fotos',
      photosPlaceholder: 'Fotos hochladen (jpeg, png)',
      lifetime: 'Angebotszeitraum',
      lifetimeDescription: 'Geben Sie an wie lange das Angebot bestehen soll.',
      startDate: 'Startdatum',
      endDate: 'Enddatum',
      minCharsHelper: 'Bitte beschreiben Sie Ihr Angebot mit mindestens 150 Zeichen'
    },
    personalContacts: {
      yourEmail: 'Ihre E-Mail-Adresse',
      yourPhoneNumber: 'Ihre Telefonnummer'
    }
  },
  alerts: {
    saveSuccessful: 'Das Angebot wurde erfolgreich gespeichert',
    saveFailed: 'Das Angebot konnte nicht gespeichert werden'
  },
  noListings: 'Derzeit gibt es keine Aushänge am schwarzen Brett',
  notFound: 'Das Angebot konnte nicht gefunden werden',
  openFailed: 'Das Angebot konnte nicht geöffnet werden',
  ownListings: 'Eigene Angebote'
};

export default de;
export type ListingsTranslation = typeof de;
